/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function ChallengeIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon-game">
        <circle
          id="Oval"
          cx="78.5"
          cy="78.5"
          r="77.5"
          fill={mainColor}
          stroke="white"
          stroke-width="2"
        />
        <g id="ziel">
          <path
            id="Path"
            d="M77.5 124C100.42 124 119 105.42 119 82.5C119 75.4478 117.246 68.812 114.147 62.9997C113.807 63.0481 113.459 63.0675 113.12 63.0675C112.926 63.0675 112.723 63.0578 112.519 63.0481L107.24 62.6412L103.442 66.4386C106.339 71.1079 108.015 76.6102 108.015 82.5C108.015 99.346 94.3557 113.005 77.5096 113.005C60.6637 113.005 46.995 99.346 46.995 82.5C46.995 65.654 60.6539 51.995 77.4999 51.995C83.3995 51.995 88.9017 53.6709 93.5612 56.5674L97.0001 53.1284L96.5352 47.0739C96.4965 46.5895 96.5061 46.1052 96.5545 45.6305C90.8487 42.6759 84.3681 41 77.4902 41C54.58 41 36 59.5801 36 82.5C36 105.42 54.5801 124 77.5 124Z"
            fill={secondaryColor}
          />
          <path
            id="Path_2"
            d="M77.5 71.5094C77.7722 71.5094 78.0444 71.5189 78.3165 71.5378L86.0052 64.0384L86.1704 63.8772C83.5362 62.6731 80.6008 62 77.5 62C66.1759 62 57 70.95 57 81.9953C57 93.0405 66.1759 102 77.5 102C88.824 102 98 93.05 98 82.0047C98 78.9803 97.3097 76.1172 96.0753 73.5478L95.9102 73.7089L88.2213 81.2082C88.2408 81.4738 88.2505 81.7394 88.2505 82.0046C88.2505 87.7975 83.439 92.5001 77.4902 92.5001C71.5415 92.5001 66.7396 87.7974 66.7396 82.0046C66.7398 76.2119 71.561 71.5094 77.5 71.5094Z"
            fill={secondaryColor}
          />
          <path
            id="Path_3"
            d="M120.264 45.9242L122.76 43.444C123.9 42.3113 123.9 40.4853 122.76 39.3527L121.031 37.6243C120.461 37.058 119.714 36.7748 118.977 36.7748C118.24 36.7748 117.483 37.058 116.923 37.6243L114.064 40.4658L113.474 32.8983C113.435 32.3418 112.973 32 112.492 32C112.246 32 112 32.0879 111.804 32.2832L100.553 43.4635C99.5404 44.4692 99.0195 45.8656 99.1277 47.2912L99.1571 47.7306L99.6976 54.7317L95.6294 58.7742L88.3087 66.0488L88.1418 66.2148L81.0569 73.255L77.9124 76.3797C77.4997 76.7897 77.2442 77.3366 77.2049 77.9126L77.0084 80.3636C76.8905 81.7892 78.0303 83 79.4552 83C79.4944 83 79.5338 83 79.5829 83L82.1869 82.873C82.7961 82.8436 83.3759 82.5898 83.7985 82.1601L86.9135 79.0648L93.9983 72.0246L94.1655 71.8586L101.486 64.5841L105.908 60.1901L112.334 60.6783L112.619 60.6978C112.747 60.7076 112.875 60.7076 112.993 60.7076C114.29 60.7076 115.538 60.1998 116.471 59.282L127.713 48.1114C128.302 47.5255 127.929 46.51 127.094 46.4514L120.264 45.9242Z"
            fill={secondaryColor}
          />
        </g>
      </g>
    </svg>
  );
}

ChallengeIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
ChallengeIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(ChallengeIcon);
memoized.displayName = 'ChallengeIcon';
export default memoized;
